import * as React from 'react';

import Frame from '../Frame';
import type { EmbedProps as Props } from '.';

function Vimeo(props: Props) {
  // Extract matches directly within the component
  const extractMatches = (href: string) => {
    const regex =
      /(http|https)?:\/\/(www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:\/|\?)?([\d\w]+)?/;

    return href.match(regex);
  };

  // Extract the matches from the URL
  const matches = extractMatches(props.attrs.href);
  if (!matches) return null; // If no match is found, return null

  const videoId = matches[4];
  const hId = matches[5];

  // Construct the Vimeo embed URL
  const embedUrl = `https://player.vimeo.com/video/${videoId}?byline=0${hId ? `&h=${hId}` : ''}`;

  return <Frame {...props} src={embedUrl} title={`Vimeo Embed (${videoId})`} height="412px" border={false} />;
}

Vimeo.isMatch = (href: string) => {
  const regex =
    /^(https?):\/\/(www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)?(\d+)(\/)?(?:\?.*|#.*)?$/i;

  return regex.test(href);
};

export default Vimeo;
